<template>
    <button @click="$emit('click')" :class="`text-skin-${text_color} font-normal px-m py-${py} rounded-40 border-skin-${border_color} focus:outline-none bg-button`">
        {{text}}
    </button>
</template>

<script>
export default {
    props:{
        text:{
            required: true,
            type: String,
        },
        border_color:{
            default: '',
            type: String
        },
        text_color:{
            default: '#DBDBDB',
            type: String
        },
        py:{
            type:String,
            default: '10px'
        }
    }
}
</script>